import { createFileRoute } from '@tanstack/react-router';
import { CreditCard } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/dashboard/memberships/')({
  component: MembershipsIndex,
});

function MembershipsIndex() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-muted-foreground gap-2">
      <CreditCard size={32} className="text-muted-foreground/30" />
      <p className="text-sm">Select a membership to view details</p>
    </div>
  );
}
